import { HostBinding, Component, OnInit } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { NgForm } from '@angular/forms';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { NotificationsService } from 'angular2-notifications';
import { RECAPTCHA_KEY } from 'app/config';
import { AcompanhamentoService } from './shared/acompanhamento.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.scss'],
  animations: [routerTransition],
})
export class AcompanhamentoComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public cpf;
  public cpfValido = null;
  public recaptchaKey = RECAPTCHA_KEY;
  public captchaStatus = false;
  public loading = false;

  flagPosGraduacao2ViaBoleto: any;

  constructor(
    private pessoaService: PessoaService,
    private acompanhamentoService: AcompanhamentoService,
    private notificacao: NotificationsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.flagPosGraduacao2ViaBoleto = environment.flagPosGraduacao2ViaBoleto;
    if (this.flagPosGraduacao2ViaBoleto === 'false') {
      return this.router.navigate(['/']);
    }
  }

  validaCpf() {
    if (this.cpf) {
      return this.cpfValido = this.pessoaService.validarCpf(this.cpf);
    }
    return this.cpfValido = null;
  }

  handleCaptcha($event) {
    this.captchaStatus = typeof $event === 'string' && $event.length > 10;
  }


  login(form: NgForm) {
    this.loading = true;
    if (form.valid && this.captchaStatus) {
      this.acompanhamentoService.getInscricoes(this.cpf.replace(/\D+/g, '')).subscribe(
        (resp: any) =>  {
          this.acompanhamentoService.setDadosInscricoes(resp);
          this.loading = false;
          this.nextStep();
        },
        (err: any) => {
         this.cpf = null;
         this.loading = false;
        },
      );
    }
  }

  nextStep() {
    this.router.navigate([`../inscricoes`], { relativeTo: this.route });
  }


}
